// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component } from "react";
const RIOTBAR_SCRIPT_ID = "riotbar-script";
export default class RiotBarLoader extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    // start loading
    this.loadRiotBar();
  }
  render() {
    return null; // we dont actually render anything, the riotbar script does
  }
  getRiotBarUrl() {
    const {
      environment = "production",
      locale,
      product
    } = this.props;
    let {
      version
    } = this.props;
    // Default the cdnHost and environmentPath vars
    let cdnHost = "lolstatic-a.akamaihd.net";
    let environmentPath = "live";
    // If the environment is not production, reset the cdn host and environment path
    if (!["production", "prod", "live"].includes(environment)) {
      cdnHost = "cdn.rgpub.io";
      environmentPath = "test";
      // If no version was passed, and we're in a staging environment, we use master
      if (!version) {
        version = "master";
      }
      // New CDN strategy for test only
      return "https://".concat(cdnHost, "/private/").concat(environmentPath, "/riotbar/").concat(version, "/").concat(product, ".").concat(locale, ".js");
    }
    // if no version has been set, set it to latest
    if (!version) {
      version = "latest";
    }
    return "https://".concat(cdnHost, "/riotbar/").concat(environmentPath, "/").concat(version, "/").concat(product, ".").concat(locale, ".js");
  }
  loadRiotBar() {
    if (!document.getElementById(RIOTBAR_SCRIPT_ID)) {
      const scriptEl = document.createElement("script");
      scriptEl.src = this.getRiotBarUrl();
      scriptEl.id = RIOTBAR_SCRIPT_ID;
      if (this.props.onLoad && typeof this.props.onLoad === "function") {
        const onloadFunc = this.props.onLoad;
        document.addEventListener("riotbar_onshowcomplete", function () {
          onloadFunc();
        });
      }
      if (this.props.onAuthUpdate && typeof this.props.onAuthUpdate === "function") {
        const onAuthUpdateFunc = this.props.onAuthUpdate;
        document.addEventListener("riotbar_authcheckcomplete", function () {
          onAuthUpdateFunc();
        });
      }
      document.getElementsByTagName("head")[0].appendChild(scriptEl);
    }
  }
}